// Angular Core Modules
import { Component, inject, Input, input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';

// Third Party Modules
import { CardModule } from 'primeng/card';
import { PrimeTemplate } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';

// Application Modules and Utils
import { Consumer } from '@app/resources/services';
import { NonMemberRecentTransactionsListComponent } from '@app/areas/non-members/components/non-member-recent-transactions-list/non-member-recent-transactions-list.component';
import { NonMemberInformationComponent } from '@app/areas/non-members/components/non-member-information/non-member-information.component';
import { PortalTheme } from '@app/@shared/models';
import { CssValidatorService } from '@app/@shared/services/css-validator.service';

@Component({
  selector: 'app-non-member-display-card',
  standalone: true,
  imports: [
    CardModule,
    PrimeTemplate,
    AvatarModule,
    NgIf,
    NonMemberRecentTransactionsListComponent,
    NonMemberInformationComponent,
  ],
  templateUrl: './non-member-display-card.component.html',
  styleUrl: './non-member-display-card.component.scss',
})
export class NonMemberDisplayCardComponent implements OnInit {
  private readonly cssValidatorService = inject(CssValidatorService);
  nonMember = input.required<Consumer>();
  @Input() theme: PortalTheme | undefined;

  ngOnInit(): void {
    this.setCSSCustomProperties();
  }

  private setCSSCustomProperties(): void {
    if (this.theme) {
      // Set CSS custom properties based on the theme
      document.documentElement.style.setProperty('--primary', this.theme.primary);
      document.documentElement.style.setProperty('--header-bg-primary', this.theme.header?.backgroundColor);
      document.documentElement.style.setProperty('--form-header-text-color', this.theme.form?.header?.textColor);
      document.documentElement.style.setProperty('--form-bg-color', this.theme.form?.backgroundColor);
      document.documentElement.style.setProperty('--text--color-default', this.theme.defaultTextColor);
      // Check for undefined CSS variables
      this.cssValidatorService.checkUndefinedCssVariables('NonMemberDisplayCardComponent');
    }
  }
}
